import { IApiSplitTicketItem } from 'features/ticketList/services/types/ticket';
import { CategoryType } from './autoBalanceHelpers';
import { Avatar, Form } from 'antd';
import styled from 'styled-components';
import colorTheme from 'constants/color';
import Close from 'assets/Icons/close';
import CurrencyInputPrecision from 'components/CurrencyInputPrecision';
import Box from 'components/Box';
import Text from 'components/Text';
import Change from 'assets/Icons/change';
import ChangeServiceModal, { ChangeServiceModalRef } from '../ChangeServiceModal';
import { useRef, useState } from 'react';
import ModalChooseStaffFilter from 'widgets/Staff/DropDown/ModalChooseStaffFilter';
import { IStaffItemData } from 'services/shop/types/staff';

type StaffRowProps = {
  value?: IApiSplitTicketItem;
  name: any;
  remove?: () => void;
  disabledRemove?: boolean;
  disableSupplyFee?: boolean;
  disableDiscount?: boolean;
  onFieldChange?: (category: CategoryType, value: number) => void;
  onFocus?: (category: CategoryType) => void;
  onBlur?: (category: CategoryType) => void;
  filterStaff?: (staffs: IStaffItemData[]) => IStaffItemData[];
};

const StaffRow = ({
  value,
  name,
  remove,
  disableDiscount,
  disableSupplyFee,
  onFieldChange,
  onFocus,
  onBlur,
  filterStaff,
}: StaffRowProps) => {
  const useChangeServiceModalRef = useRef<ChangeServiceModalRef>(null);
  const [chooseStaffVisible, setChooseStaffVisible] = useState(false);

  const form = Form.useFormInstance<IApiSplitTicketItem>();

  const handleChangeStaff = (staff: IStaffItemData) => {
    form.setFieldValue(['staffs', name, 'staffId'], staff.id);
    form.setFieldValue(['staffs', name, 'staffName'], staff.firstName);
    form.setFieldValue(['staffs', name, 'avatar'], staff.urlImage);
    setChooseStaffVisible(false);
  };

  return (
    <>
      <tr>
        <td className='no-style'>
          <div className='container-box'>
            <ServicesBox>
              <Form.Item
                noStyle
                name={[name, 'service']}
                rules={[{ required: true, message: 'Please select at least one service' }]}
              >
                <input
                  className='service-name'
                  placeholder='Select/Input service'
                />
              </Form.Item>

              <button
                type='button'
                className='btn-change-service'
                onClick={() =>
                  useChangeServiceModalRef.current?.open((_, serviceObject) => {
                    form.setFieldValue(
                      ['staffs', name, 'service'],
                      serviceObject?.serviceName || ''
                    );
                  })
                }
              >
                <Change fill='#FFFFFF' width={20} height={20} />
              </button>
            </ServicesBox>
          </div>
        </td>
        <td className='staff-info no-style'>
          <div className='container-box staff-col'>
            <Box width='100%' display='flex' justifyContent='space-between'>
              <Box display='flex' gap='2' alignItems='center'>
                <Avatar src={value?.avatar || 'fail'} size={50}>
                  {value?.staffName?.[0] || 'A'}
                </Avatar>
                <Text variant='H4' className='medium-text'>
                  {value?.staffName}
                </Text>
              </Box>
              <button type='button' className='btn-change-service' onClick={() => setChooseStaffVisible(true)}>
                <Change fill={colorTheme.v2_blue_3} width={24} />
              </button>
            </Box>
          </div>
        </td>
        <td>
          <div className='container-box with-input'>
            <Form.Item noStyle name={[name, 'amount']}>
              <CurrencyInputPrecision
                onChangeDebounce={(value) => onFieldChange?.('amount', value)}
                onFocus={() => onFocus?.('amount')}
                onBlur={() => onBlur?.('amount')}
              />
            </Form.Item>
          </div>
        </td>
        <td>
          <div className='container-box with-input'>
            <Form.Item noStyle name={[name, 'tip']}>
              <CurrencyInputPrecision
                onChangeDebounce={(value) => onFieldChange?.('tip', value)}
                onFocus={() => onFocus?.('tip')}
                onBlur={() => onBlur?.('tip')}
              />
            </Form.Item>
          </div>
        </td>
        <td>
          <div className='container-box with-input'>
            <Form.Item noStyle name={[name, 'discount']}>
              <CurrencyInputPrecision
                disabled={disableDiscount}
                onChangeDebounce={(value) => onFieldChange?.('discount', value)}
                onFocus={() => onFocus?.('discount')}
                onBlur={() => onBlur?.('discount')}
              />
            </Form.Item>
          </div>
        </td>
        <td>
          <div className='container-box with-input'>
            <Form.Item noStyle name={[name, 'supplyFee']}>
              <CurrencyInputPrecision
                disabled={disableSupplyFee}
                onChangeDebounce={(value) => onFieldChange?.('supplyFee', value)}
                onFocus={() => onFocus?.('supplyFee')}
                onBlur={() => onBlur?.('supplyFee')}
              />
            </Form.Item>
          </div>
        </td>
        <td className='action'>
          <div className='container-box'>
            {/* {!disabledRemove && ( */}
            <button type='button' className='btn-delete' onClick={remove}>
              <Close fill={colorTheme.v2_primary_bg_6} />
            </button>
            {/* )} */}
          </div>
        </td>
      </tr>
      <ChangeServiceModal ref={useChangeServiceModalRef} />
      <ModalChooseStaffFilter
        filter={filterStaff}
        visible={chooseStaffVisible}
        onChooseStaff={handleChangeStaff}
        onClose={() => setChooseStaffVisible(false)}
      />
    </>
  );
};

export default StaffRow;

const ServicesBox = styled.div`
  display: flex;
  border: 1px solid ${colorTheme.v2_border_3};
  width: 100%;
  height: 54px;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  border-radius: 4px;

  .btn-change-service {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    margin-left: 16px;
    height: 100%;
    background: ${colorTheme.v2_blue_3};
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .service-name {
    width: 100%;
    height: 90%;
    font-size: 1.5rem;
    font-weight: 500;
    font-family: 'Poppins';
    border: none;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

    &:focus {
      outline: none;
    }
  }
`;
